import { i18n } from "@src/utils/i18n";
import * as nls from "./nls";
const I18N = i18n(nls);
const text = I18N;
import { APP_TYPE } from '@src/utils/common'

export const innter = [
  {
    key: "icon",
    require: true, // 图标
    isEdit: false,
    type: 0,
    title: text?.icon?.title,
    tip: text?.icon?.tip,
    errorTip: text?.icon?.errorTip,
    aliasName: "",
    secret: "",
    value: "",
    batchId: "",
    imgType: "default",
    appIncludes: [APP_TYPE.innerapp, APP_TYPE.isv]
  },
  {
    key: "nameCn",
    require: true, // 中文名
    isEdit: false,
    type: 1,
    title: text?.CnName?.title1,
    placeholder: text?.CnName?.placeholder,
    tip: text?.CnName?.tip,
    isShowError: false,
    errorTip: text?.CnName?.errorTip,
    errorTip: "",
    value: "",
    maxlength: 20,
    appIncludes: [APP_TYPE.innerapp, APP_TYPE.isv]
  },
  {
    key: "nameEn",
    require: true, // 英文名
    isEdit: false,
    type: 1,
    title: text?.EnName?.title1,
    placeholder: text?.EnName?.placeholder,
    tip: text?.EnName?.tip,
    isShowError: false,
    errorTip: text?.EnName?.errorTip,
    errorTip: "",
    value: "",
    maxlength: 50,
    appIncludes: [APP_TYPE.innerapp, APP_TYPE.isv]
  },
  {
    key: "aliasName",
    require: false, // client_id
    isEdit: false,
    isShow: true,
    type: 1,
    title: "client_id",
    placeholder: text?.EnName?.placeholder,
    tip: text?.EnName?.tip,
    isShowError: false,
    errorTip: "",
    value: "",
    maxlength: 50,
    tigType: "client_id",
    appIncludes: [APP_TYPE.innerapp, APP_TYPE.isv]
  },
  {
    key: "secret",
    require: false, // client_secret
    isEdit: false,
    isShow: true,
    isReset: true,
    type: 1,
    title: "client_secret",
    placeholder: text?.EnName?.placeholder,
    tip: text?.EnName?.tip,
    isShowError: false,
    errorTip: "",
    value: "",
    maxlength: 50,
    tigType: "client_secret",
    appIncludes: [APP_TYPE.innerapp, APP_TYPE.isv]
  },
  {
    key: "descCn",
    require: false, // 中文简介
    isEdit: false,
    type: 2,
    title: text?.CnIntroduce?.title,
    placeholder: text?.CnIntroduce?.placeholder,
    tip: text?.CnIntroduce?.tip,
    isShowError: false,
    errorTip: text?.CnIntroduce?.errorTip,
    value: "",
    maxlength: 300,
    className: "textarea",
    appIncludes: [APP_TYPE.innerapp]
  },
  {
    key: "descEn",
    require: false, // 英文简介
    isEdit: false,
    type: 2,
    title: text?.EnIntroduce?.title,
    placeholder: text?.EnIntroduce?.placeholder,
    tip: text?.EnIntroduce?.tip,
    isShowError: false,
    errorTip: text?.EnIntroduce?.errorTip,
    value: "",
    maxlength: 600,
    className: "textarea",
    appIncludes: [APP_TYPE.innerapp]
  },
  {
    key: "supportInfo",
    require: false, // 用户支持
    isEdit: false,
    type: 1,
    title: text?.userSupport?.title,
    placeholder: text?.userSupport?.placeholder,
    tip: text?.userSupport?.tip,
    isShowError: false,
    errorTip: text?.userSupport?.errorTip,
    value: "",
    maxlength: 50,
    appIncludes: [APP_TYPE.innerapp]
  },
  {
    key: "keywords",
    require: false, // 关键词
    isEdit: false,
    type: 1,
    title: text?.keyWords?.title,
    placeholder: text?.keyWords?.placeholder,
    tip: text?.keyWords?.tip,
    isShowError: false,
    errorTip: text?.keyWords?.errorTip,
    value: "",
    maxlength: 50,
    appIncludes: [APP_TYPE.innerapp]
  },
  {
    key: "serviceFrom",
    require: false, // 后台地址
    isEdit: false,
    type: 1, // input
    title: text?.backendAdd?.title,
    placeholder: text?.backendAdd?.placeholder,
    tip: text?.backendAdd?.tip,
    isShowError: false,
    errorTip: text?.backendAdd?.errorTip,
    value: "",
    maxlength: 500,
    appIncludes: [APP_TYPE.innerapp ]
  },
  {
    key: "privacyLinkCn",
    require: false, // 隐私地址中文
    isEdit: false,
    type: 1, // input
    title: text?.privacyLinkCN?.title,
    placeholder: text?.privacyLinkCN?.placeholder,
    tip: text?.privacyLinkCN?.tip,
    isShowError: false,
    errorTip: text?.privacyLinkCN?.errorTip,
    value: "",
    maxlength: 100,
    appIncludes: [APP_TYPE.innerapp, APP_TYPE.isv]
  },
  {
    key: "privacyLinkEn",
    require: false, // 隐私地址英文
    isEdit: false,
    type: 1, // input
    title: text?.privacyLinkEN?.title,
    placeholder: text?.privacyLinkEN?.placeholder,
    tip: text?.privacyLinkEN?.tip,
    isShowError: false,
    errorTip: text?.privacyLinkEN?.errorTip,
    value: "",
    maxlength: 100,
    appIncludes: [APP_TYPE.innerapp, APP_TYPE.isv]
  }
];

export const getItemByKey = (dataSource, key) => {
  return dataSource?.find(item => item.key === key);
};

export const setItemByKey = (dataSource, key, value) => {
  const index = dataSource?.findIndex(item => item.key === key);
  if (index >= 0) {
    dataSource[index] = { ...dataSource[index], ...value };
  }
};
